/**
 * ApiConfig.js
 * 
 * This file centralizes all API endpoints used in the application.
 * It provides a single place to manage and update API URLs.
 */

// Base URL for all API endpoints
export const BASE_URL = 'https://hirewise.at';

export const SUPABASE_STORAGE_URL = 'https://ydjgxcpbbnhoucqqctds.supabase.co/storage/v1';

// export const API_BASE_URL = 'https://upperco.app.n8n.cloud/webhook';
// export const API_BASE_URL = 'https://api.hirewise.at';
export const API_BASE_URL = 'https://hirewise-backend.upper.co/webhook';

export const API_BASE_URL_SELFHOST = 'https://hirewise-backend.upper.co/webhook';

// API endpoints
export const API_ENDPOINTS = {

  ///////////////////////////////////
  // Job related endpoints
  ///////////////////////////////////

  GET_JOB: `${API_BASE_URL}/get-job`,  
  GET_JOBS: `${API_BASE_URL}/get-jobs`,
  GET_JOB_CANDIDATES: `${API_BASE_URL}/get-candidates`,
  GET_JOB_EVALUATIONS: `${API_BASE_URL}/get-evaluations-for-job`,
  NEW_JOB_API: `${API_BASE_URL}/new-job-api`,
  NEW_JOB: `${API_BASE_URL}/new-job`,
  DELETE_JOB: `${API_BASE_URL}/delete-job`,

  UPDATE_JOB_JR: `${API_BASE_URL}/update-jr`,

  ///////////////////////////////////
  // Candidate related endpoints
  ///////////////////////////////////

  ADD_CANDIDATE: `${API_BASE_URL}/add-candidate`,  
  UPLOAD_RESUME: `${API_BASE_URL}/upload-resume`, 
  GET_FULL_CANDIDATE_DATA: `${API_BASE_URL}/get-candidate-data`,
  GET_CANDIDATE_EVALS: `${API_BASE_URL}/get-candidate-evals`,
  DELETE_CANDIDATE: `${API_BASE_URL}/delete-candidate`,
  GENERATE_JOB_PROFILE_FIT: `${API_BASE_URL}/generate-job-profile-fit`,

  GET_PUBLIC_CANDIDATE_REPORT: `${API_BASE_URL}/get-public-candidate-report`,

  ///////////////////////////////////
  // Talent related endpoints
  ///////////////////////////////////

  GET_TALENT: `${API_BASE_URL}/get-talent`,
  GET_TALENT_DATA: `${API_BASE_URL}/get-talentdata2`,
  NEW_TALENT_API: `${API_BASE_URL}/new-talent-api`,
  NEW_TALENT: `${API_BASE_URL}/new-talent`,
  DELETE_TALENT: `${API_BASE_URL}/delete-talent`,
  GET_TALENT_EVALS: `${API_BASE_URL}/get-talent-evals`,
  GET_TALENT_EVAL_DETAILS: `${API_BASE_URL}/get-talent-eval-details`,

  UPDATE_TALENT_PROFILE_JSON: `${API_BASE_URL}/update-talent-profile-json`,

  GET_PUBLIC_TALENT_REPORT: `${API_BASE_URL}/get-public-talent-report`,

  CALL_CALLBACK: `${API_BASE_URL}/call-callback`, 

  ///////////////////////////////////
  // Evaluation & Eval related endpoints
  ///////////////////////////////////  

  GET_EVALUATION_DETAILS: `${API_BASE_URL}/get-evaluation-details`,
  DELETE_EVALUATION: `${API_BASE_URL}/delete-evaluation`,
  GET_EVAL_DETAILS: `${API_BASE_URL}/get-eval-details`,

  GET_ASSIGNABLE_EVALUATIONS: `${API_BASE_URL}/get-assignable-evaluations`,

  ASSIGN_EVALUATION: `${API_BASE_URL}/assign-evaluation`, 

  GET_USER_EVALUATIONS: `${API_BASE_URL}/get-user-evaluations`,  

  V1_CREATE_EVALUATION: `${API_BASE_URL}/v1-create-evaluation`,  
  V1_CREATE_QC: `${API_BASE_URL}/v1-create-qc`,  

  EDIT_EVAL_SETTINGS: `${API_BASE_URL}/edit-eval-settings`,  
  EDIT_EVALUATION_SETTINGS: `${API_BASE_URL}/edit-evaluation-settings`,  

  EVALUATE_TALENT: `${API_BASE_URL}/evaluate-talent`,
  EVALUATE_CANDIDATE: `${API_BASE_URL}/evaluate-candidate`,

  LOAD_USER_DEFAULT_SETTINGS:  `${API_BASE_URL}/load-user-settings`,

  ///////////////////////////////////
  // Questionnaire related endpoints
  ///////////////////////////////////  

  UPDATE_QUESTIONNAIRE_JSON: `${API_BASE_URL}/update-questionnaire-json`,  

  ///////////////////////////////////
  // Challenge related endpoints
  ///////////////////////////////////  

  UPDATE_CHALLENGE_JSON: `${API_BASE_URL}/update-challenge-json`,
  GENERATE_CHALLENGE_QUESTION: `${API_BASE_URL}/generate-challenge-question`,
  
  // SIMULATE_SAVE_CHALLENGE: `${API_BASE_URL}/simulate-save-challenge`,  // decided to do this in n8n

  ///////////////////////////////////
  // Assessment related endpoints
  ///////////////////////////////////

  GET_PROFILE_ASSESSMENT: `${API_BASE_URL}/get-profileassessment`,  
  
  ANSWER_QUESTIONNAIRE: `${API_BASE_URL_SELFHOST}/answerquestionnaire`,
  SOLVE_CHALLENGE: `${API_BASE_URL_SELFHOST}/solvechallenge`,
  
  ///////////////////////////////////
  // Authentication
  ///////////////////////////////////
  
  LOGIN: `${API_BASE_URL_SELFHOST}/admin-login`, 
  REQUEST_PASSWORD_RESET: `${API_BASE_URL_SELFHOST}/forgot-password`,
  RESET_PASSWORD: `${API_BASE_URL_SELFHOST}/change-password`,

  ///////////////////////////////////
  // Library related endpoints
  ///////////////////////////////////
  LIB_GET_CHALLENGE_QUESTIONS: `${API_BASE_URL_SELFHOST}/lib-get-challenge-questions`, 
  LIB_ADD_ITEM: `${API_BASE_URL_SELFHOST}/add-to-library`, 


  ///////////////////////////////////
  // Settings related endpoints
  ///////////////////////////////////
  LOAD_SETTINGS: `${API_BASE_URL_SELFHOST}/load-settings`, 
  SAVE_SETTINGS: `${API_BASE_URL_SELFHOST}/save-settings`, 

  GET_ALL_CATEGORIES: `${API_BASE_URL_SELFHOST}/get-all-role-categories`,   

  ///////////////////////////////////
  // Prompts endpoints
  ///////////////////////////////////
  GET_UNIQUE_CAT_PAIRS: `${API_BASE_URL_SELFHOST}/get-unique-cat-pairs`, 
  GET_UNIQUE_ACTIONS: `${API_BASE_URL_SELFHOST}/get-unique-actions`, 
  GET_PROMPT: `${API_BASE_URL_SELFHOST}/get-prompt`, 
  GET_ALL_UNIQUE_PROMPTS: `${API_BASE_URL_SELFHOST}/get-all-unique-prompts`, 
  SAVE_PROMPTS: `${API_BASE_URL_SELFHOST}/save-prompts`, 
  CLONE_PROMPTS: `${API_BASE_URL_SELFHOST}/clone-prompts`, 
  CLONE_PROMPT_BY_ID: `${API_BASE_URL_SELFHOST}/clone-prompt-by-id`,

  EDIT_ROLE_ITEM: `${API_BASE_URL_SELFHOST}/edit-role-item`,

  GET_SHARDS: `${API_BASE_URL_SELFHOST}/get-shards`, 
  SAVE_SHARD: `${API_BASE_URL_SELFHOST}/save-shard`, 
  CREATE_SHARD: `${API_BASE_URL_SELFHOST}/create-shard`, 
  DELETE_SHARD: `${API_BASE_URL_SELFHOST}/delete-shard`, 

  ///////////////////////////////////
  // Misc endpoints
  ///////////////////////////////////
  MANAGE_LINKS: `${API_BASE_URL_SELFHOST}/manage-public-links`, 
  SIGN_URL: `${API_BASE_URL}/sign-url`,

};

/**
 * Helper function to build URLs with query parameters
 * @param {string} endpoint - The API endpoint
 * @param {Object} params - Query parameters as key-value pairs
 * @returns {string} - The complete URL with query parameters
 */
export const buildUrl = (endpoint, params = {}) => {
  const url = new URL(endpoint);
  
  Object.keys(params).forEach(key => {
    if (params[key] !== undefined && params[key] !== null) {
      url.searchParams.append(key, params[key]);
    }
  });
  
  return url.toString();
};

export default {
  API_BASE_URL,
  API_ENDPOINTS,
  buildUrl,
};
